import { getScrollContainer } from './listenToPostScroll';

const scrollPostToTop = () => {
  const scrollContainer = getScrollContainer();
  if (scrollContainer) {
    scrollContainer.scrollTop = 0;
  }
};

export default scrollPostToTop;
